import ContactCard from "../../components/ContactCard";

export default function ContactSection () {
  const socialLinks = [
    {
      platform: "instagram",
      title: "Instagram",
      description: "Follow our updates",
      url: "https://www.instagram.com/ecom_tamil/",
      target: "_blank",
      rel: "noopener noreferrer",
      borderColor: "border-pink-500",
      hoverBg: "hover:bg-pink-50"
    },
    {
      platform: "facebook",
      title: "Facebook",
      description: "Join our community",
      url: "https://www.facebook.com/profile.php?id=61579631565605",
      target: "_blank",
      rel: "noopener noreferrer",
      borderColor: "border-blue-600",
      hoverBg: "hover:bg-blue-50"
    },
    {
      platform: "whatsapp",
      title: "WhatsApp",
      description: "Chat with us",
      url: "https://wa.me/1234567890",
      target: "_blank",
      rel: "noopener noreferrer",
      borderColor: "border-green-500",
      hoverBg: "hover:bg-green-50"
    },
    {
      platform: "email",
      title: "Email",
      description: "Send us a message",
      url: "mailto:yourmail@example.com",
      target: "_self",
      rel: null,
      borderColor: "border-red-500",
      hoverBg: "hover:bg-red-50"
    }
  ];

  return (
    <section id="contact" className="py-16 bg-white relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] -mr-48 -mt-48 rounded-full bg-amber-400/10 blur-[120px] animate-pulse"></div>
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] -ml-48 -mb-48 rounded-full bg-orange-400/10 blur-[120px] animate-pulse" style={{animationDelay: '1.5s'}}></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-amber-300/5 blur-[150px]"></div>
      
      {/* Subtle grid pattern */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmIiIGZpbGwtb3BhY2l0eT0iMC4wNCI+PHBhdGggZD0iTTM2IDM0djItSDI0di0yaDEyek0zNiAyNHYySDI0di0yaDEyeiIvPjwvZz48L2c+PC9zdmc+')] opacity-50"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          {/* Decorative badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-50 border border-amber-200/50 text-xs font-semibold text-amber-600 uppercase tracking-wider mb-6">
            <span className="flex items-center justify-center w-2 h-2 rounded-full bg-amber-500 animate-pulse"></span>
            Connect With Us
          </div>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-6 tracking-tight">
            Get in <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-500 via-orange-500 to-amber-600">Touch</span>
          </h2>
          
          <div className="w-24 h-1.5 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full mx-auto mb-6"></div>
          
          <p className="max-w-2xl mx-auto text-gray-600 text-lg leading-relaxed">
            Stay connected with us through our social platforms. We'd love to hear from you.
          </p>
        </div>

        {/* Contact Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {socialLinks?.map((link, index) => (
            <ContactCard
              key={index}
              index={index}
              platform={link?.platform}
              title={link?.title}
              description={link?.description}
              url={link?.url}
              target={link?.target}
              rel={link?.rel}
              borderColor={link?.borderColor}
              hoverBg={link?.hoverBg}
            />
          ))}
        </div>

        {/* Contact Info Section */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8 bg-amber-50/50 p-8 rounded-3xl border border-amber-100 shadow-sm relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-amber-400/10 rounded-full blur-2xl"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-orange-400/10 rounded-full blur-2xl"></div>
          
          <div className="flex flex-col justify-center space-y-6 relative z-10">
            <h3 className="text-xl font-bold text-gray-900">Reach Out to Us</h3>
            <div className="space-y-4">
              <div className="flex items-center gap-4 text-gray-700 group">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-sm border border-amber-100 group-hover:border-amber-300 transition-colors">
                  <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                </div>
                <a href="mailto:ecomtamil.official@gmail.com" className="font-medium hover:text-amber-600 transition-colors">ecomtamil.official@gmail.com</a>
              </div>
              <div className="flex items-center gap-4 text-gray-700 group">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-sm border border-amber-100 group-hover:border-amber-300 transition-colors">
                  <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                </div>
                <a href="tel:9360326064" className="font-medium hover:text-amber-600 transition-colors">9360326064</a>
              </div>
            </div>
          </div>
          
          <div className="flex flex-col justify-center border-t md:border-t-0 md:border-l border-amber-200/60 pt-8 md:pt-0 md:pl-10 relative z-10">
            <h3 className="text-xl font-bold text-gray-900 mb-6">Our Office</h3>
            <div className="flex items-start gap-4 text-gray-700">
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-sm border border-amber-100 shrink-0">
                <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
              </div>
              <address className="not-italic text-sm text-gray-600">
                <span className="block font-semibold text-gray-800 mb-1">Building No 5, Bajanai Koil Street</span>
                <span className="block">Hastinapuram, Chennai</span>
                <span className="block">Chengalpattu, Tamil Nadu</span>
                <span className="block mt-1 font-medium">PIN Code: 600064</span>
              </address>
            </div>
          </div>
        </div>

        {/* Bottom decorative element */}
        <div className="mt-16 flex justify-center items-center gap-4">
          <div className="h-px w-16 bg-gradient-to-r from-transparent to-amber-300"></div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-amber-400"></div>
            <div className="w-2 h-2 rounded-full bg-orange-400"></div>
            <div className="w-2 h-2 rounded-full bg-amber-400"></div>
          </div>
          <div className="h-px w-16 bg-gradient-to-l from-transparent to-amber-300"></div>
        </div>
      </div>
    </section>
  );
};